import pb from "../../lib/pb";

/*
========================================
Prepare Payload
========================================
*/

function buildPayload(data = {}, extra = {}) {

    const payload = {

        ...data,

        ...extra

    };

    const hasFile = payload.logo instanceof File;

    if (!hasFile) {

        const cleaned = {};

        Object.entries(payload).forEach(([key, value]) => {

            if (

                value === undefined ||

                value === null ||

                value === ""

            ) {

                return;

            }

            cleaned[key] = value;

        });

        return cleaned;

    }

    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {

        if (

            value === undefined ||

            value === null ||

            value === ""

        ) {

            return;

        }

        formData.append(

            key,

            value

        );

    });

    return formData;

}

/*
========================================
Load Draft
========================================
*/

export async function loadDraft(userId) {

    try {

        return await pb
            .collection("brands")
            .getFirstListItem(

                `owner="${userId}" && status="draft"`

            );

    }

    catch {

        return null;

    }

}

/*
========================================
Load Active Brand
========================================
*/

export async function loadActiveBrand(userId) {

    try {

        return await pb
            .collection("brands")
            .getFirstListItem(

                `owner="${userId}" && status="active"`

            );

    }

    catch {

        return null;

    }

}

/*
========================================
Create Draft
========================================
*/

export async function createDraft(

    userId,

    data

) {

    const payload = buildPayload(

        {

            brandName: data.brandName,

            businessType: data.businessType,

            category: data.category,

            tagline: data.tagline,

            logo: data.logo

        },

        {

            owner: userId,

            status: "draft",

            onboardingCompleted: false,

            onboardingStep:

                data.onboardingStep || 1

        }

    );

    return await pb

        .collection("brands")

        .create(payload);

}

/*
========================================
Update Draft
========================================
*/

export async function updateDraft(

    draftId,

    data,

    onboardingStep

) {

    const payload = buildPayload(

        data,

        {

            onboardingStep

        }

    );

    return await pb

        .collection("brands")

        .update(

            draftId,

            payload

        );

}

/*
========================================
Complete Wizard
========================================
*/

export async function completeDraft(

    draftId,

    data

) {

    const payload = buildPayload(

        data,

        {

            status: "active",

            onboardingCompleted: true,

            onboardingStep: 5

        }

    );

    return await pb

        .collection("brands")

        .update(

            draftId,

            payload

        );

}

/*
========================================
Delete Draft
========================================
*/

export async function deleteDraft(

    draftId

) {

    return await pb

        .collection("brands")

        .delete(

            draftId

        );

}